/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetsMelcoModelsHoopListItem
 */
export interface AssetsMelcoModelsHoopListItem {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    english_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    metric_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    width_points?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    height_points?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    presser_foot?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    enable_templates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    backward_compatibility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    supplier_product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    supplier_product_name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    discontinued?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    english_dimensions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    metric_dimensions?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    published_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsHoopListItem
     */
    signature?: string | null;
}

export function AssetsMelcoModelsHoopListItemFromJSON(json: any): AssetsMelcoModelsHoopListItem {
    return AssetsMelcoModelsHoopListItemFromJSONTyped(json, false);
}

export function AssetsMelcoModelsHoopListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsHoopListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'english_name': !exists(json, 'english_name') ? undefined : json['english_name'],
        'metric_name': !exists(json, 'metric_name') ? undefined : json['metric_name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'width_points': !exists(json, 'width_points') ? undefined : json['width_points'],
        'height_points': !exists(json, 'height_points') ? undefined : json['height_points'],
        'presser_foot': !exists(json, 'presser_foot') ? undefined : json['presser_foot'],
        'enable_templates': !exists(json, 'enable_templates') ? undefined : json['enable_templates'],
        'backward_compatibility_id': !exists(json, 'backward_compatibility_id') ? undefined : json['backward_compatibility_id'],
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'supplier_product_id': !exists(json, 'supplier_product_id') ? undefined : json['supplier_product_id'],
        'supplier_product_name': !exists(json, 'supplier_product_name') ? undefined : json['supplier_product_name'],
        'discontinued': !exists(json, 'discontinued') ? undefined : json['discontinued'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'english_dimensions': !exists(json, 'english_dimensions') ? undefined : json['english_dimensions'],
        'metric_dimensions': !exists(json, 'metric_dimensions') ? undefined : json['metric_dimensions'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'published_date': !exists(json, 'published_date') ? undefined : (json['published_date'] === null ? null : new Date(json['published_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
    };
}

export function AssetsMelcoModelsHoopListItemToJSON(value?: AssetsMelcoModelsHoopListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'english_name': value.english_name,
        'metric_name': value.metric_name,
        'version': value.version,
        'width_points': value.width_points,
        'height_points': value.height_points,
        'presser_foot': value.presser_foot,
        'enable_templates': value.enable_templates,
        'backward_compatibility_id': value.backward_compatibility_id,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'supplier_product_id': value.supplier_product_id,
        'supplier_product_name': value.supplier_product_name,
        'discontinued': value.discontinued,
        'name': value.name,
        'english_dimensions': value.english_dimensions,
        'metric_dimensions': value.metric_dimensions,
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'published_date': value.published_date === undefined ? undefined : (value.published_date === null ? null : value.published_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'signature': value.signature,
    };
}


